import {editLinkClass} from "./EditLink";
import {useContext, useState} from "react";
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {ProjectPropertiesContext, ProjectPropertiesInner} from "../../shopdrawing/ProjectProperties";

export function ProjectPropertiesLink() {
    const [show, setShow] = useState(false);
    const ctx = useContext(ProjectPropertiesContext);

    return (
        <>
            <div className={editLinkClass} onClick={() => setShow(true)}>
                {ctx.meta.countDone + "/" + ctx.meta.totalCount}
            </div>
            {show && <Dialog2 open fullWidth maxWidth="md">
                <DialogTitle>
                    Project Properties
                </DialogTitle>
                <DialogContent>
                    <ProjectPropertiesInner collapsed={false} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShow(false)}>Close</Button>
                </DialogActions>
            </Dialog2>}
        </>
    )
}